import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';

const LayoutDashBoard = () => {
  return (
    <>
      <Header className='header' layout='dashboard' />
      <div className='container_interno dashboard'>
        <Outlet />
      </div>
      <Footer className='footer' />
    </>
  );
};

export default LayoutDashBoard;